import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { AdminAnalysisAPIServiceV1 } from '@protos/analysis_management/analysis.admin.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';

export const AdminAnalysisAPIServiceV1Client = createPromiseClient(
  AdminAnalysisAPIServiceV1,
  lmsTransport
);

export const useAdminAnalysisAPIServiceV1ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    AdminAnalysisAPIServiceV1,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
